import { useState } from 'react';
import { Download, FileText, FileSpreadsheet, ChevronDown } from '@/utils/icons';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ExportMenuProps {
  onExportPdf?: () => void;
  onExportCsv?: () => void;
  label?: string;
  className?: string;
}

export function ExportMenu({
  onExportPdf,
  onExportCsv,
  label = 'Export',
  className,
}: ExportMenuProps) {
  const [open, setOpen] = useState(false);

  const hasMultiple = !!onExportPdf && !!onExportCsv;

  // Single export action — no dropdown
  if (!hasMultiple) {
    const handler = onExportPdf ?? onExportCsv;
    const Icon = onExportPdf ? FileText : FileSpreadsheet;
    return (
      <Button variant="secondary" onClick={handler} className={className}>
        <Icon className="dls-h-4 dls-w-4 dls-mr-2" />
        {label}
      </Button>
    );
  }

  return (
    <div className={cn('dls-relative', className)}>
      <Button variant="secondary" onClick={() => setOpen(!open)}>
        <Download className="dls-h-4 dls-w-4 dls-mr-2" />
        {label}
        <ChevronDown className="dls-h-3 dls-w-3 dls-ml-1" />
      </Button>
      {open && (
        <>
          <div className="dls-fixed dls-inset-0 dls-z-40" onClick={() => setOpen(false)} />
          <div className="dls-absolute dls-right-0 dls-top-full dls-mt-1 dls-z-50 dls-bg-popover dls-border dls-rounded-md dls-shadow-20 dls-py-1 dls-min-w-[160px]">
            <button
              onClick={() => {
                onExportPdf();
                setOpen(false);
              }}
              className="dls-w-full dls-flex dls-items-center dls-gap-2 dls-px-3 dls-py-2 dls-text-sm hover:dls-bg-muted dls-transition-colors"
            >
              <FileText className="dls-h-4 dls-w-4 dls-text-status-offline" />
              Export as PDF
            </button>
            <button
              onClick={() => {
                onExportCsv();
                setOpen(false);
              }}
              className="dls-w-full dls-flex dls-items-center dls-gap-2 dls-px-3 dls-py-2 dls-text-sm hover:dls-bg-muted dls-transition-colors"
            >
              <FileSpreadsheet className="dls-h-4 dls-w-4 dls-text-status-online" />
              Export as CSV
            </button>
          </div>
        </>
      )}
    </div>
  );
}
